import ClientService from "./client.service";
export default class ClientStatusService extends ClientService {
  template = "TemplateStatus";
  icon = "ThreeUserx";
}
